import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const permissionApi = createApi({
  reducerPath: "permissions",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["UserPermissions"],
  endpoints: (builder) => ({
    getUserPermissions: builder.query({
      query: ({ token, userId }) => {
        return apiFunction({ token, userId }, "/api/admin/permissions/users/get", "POST");
      },
      providesTags: (_result, _error, { userId }) => [
        { type: "UserPermissions", id: userId },
      ],
    }),
    setUserPermissions: builder.mutation({
      query: ({ token, userId, allow, deny }) => {
        return apiFunction(
          { token, userId, allow, deny },
          "/api/admin/permissions/users/set",
          "POST"
        );
      },
      invalidatesTags: (_result, _error, { userId }) => [
        { type: "UserPermissions", id: userId },
      ],
    }),
  }),
});

export const {
  useGetUserPermissionsQuery,
  useLazyGetUserPermissionsQuery,
  useSetUserPermissionsMutation,
} = permissionApi;
